import React, { forwardRef } from 'react';

import {
  mapStyledProps,
  SizeProps,
  SpacingProps,
  TextProps,
} from '../../styles';

import { TypographyRoot } from './Typography.styled';

export type TypographyProps = SpacingProps &
  SizeProps &
  TextProps & {
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
    style?: React.CSSProperties;
    className?: string;
    numberOfLines?: number;
  };

const Typography = forwardRef<
  HTMLElement,
  React.PropsWithChildren<TypographyProps>
>((props, ref) => {
  const { children, numberOfLines = 1, tag, ...rest } = props;

  return (
    <TypographyRoot
      $numberOfLines={numberOfLines}
      as={tag}
      ref={ref}
      {...mapStyledProps(rest)}>
      {children}
    </TypographyRoot>
  );
});

Typography.displayName = 'Typography';

export default Typography;
